var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "input_business" } }, [
    _c("ul", [
      _c("li", { staticClass: "input_text" }, [
        _c("div", [
          _c("label", [
            _vm._v(_vm._s(_vm.label.businessName)),
            _c("span", { staticClass: "important" }, [_vm._v("必須")])
          ])
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.businessName,
              expression: "form.businessName"
            }
          ],
          attrs: {
            type: "text",
            maxlength: "32",
            placeholder: "施主名(物件名)・会社名など"
          },
          domProps: { value: _vm.form.businessName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "businessName", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.errors.businessName
          ? _c("div", { staticClass: "error_text" }, [
              _vm._v(_vm._s(_vm.errors.businessName))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "input_text" }, [
        _c("div", [_c("label", [_vm._v(_vm._s(_vm.label.building))])]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.building,
              expression: "form.building"
            }
          ],
          attrs: { type: "text", maxlength: "32", placeholder: "建物名" },
          domProps: { value: _vm.form.building },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "building", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "input_text" }, [
        _c("div", [
          _c("label", [
            _vm._v(_vm._s(_vm.label.postcd)),
            _c("span", { staticClass: "small_p" }, [
              _vm._v("（半角数値、ハイフン不要）")
            ]),
            _c("span", { staticClass: "important" }, [_vm._v("必須")])
          ])
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.postcd,
              expression: "form.postcd"
            }
          ],
          attrs: {
            type: "text",
            disabled: "disabled",
            oninput: "if(value.length>7)value=value.slice(0,7)",
            placeholder: "0001111"
          },
          domProps: { value: _vm.form.postcd },
          on: {
            keypress: _vm.validateNumber,
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "postcd", $event.target.value)
              },
              function($event) {
                _vm.form.postcd = _vm.inputRestNumber($event)
              }
            ]
          }
        }),
        _vm._v(" "),
        _vm.errors.postcd
          ? _c("div", { staticClass: "error_text" }, [
              _vm._v(_vm._s(_vm.errors.postcd))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "input_text2" }, [
        _c("div", [
          _c("label", [
            _vm._v(_vm._s(_vm.label.address)),
            _c("span", { staticClass: "important" }, [_vm._v("必須")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input_field" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.state,
                expression: "form.state"
              }
            ],
            attrs: {
              type: "text",
              disabled: "disabled",
              placeholder: "都道府県"
            },
            domProps: { value: _vm.form.state },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "state", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "space" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.city,
                expression: "form.city"
              }
            ],
            attrs: {
              type: "text",
              disabled: "disabled",
              placeholder: "市区町村"
            },
            domProps: { value: _vm.form.city },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "city", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.errors.state
          ? _c("div", { staticClass: "error_text" }, [
              _vm._v(_vm._s(_vm.errors.state))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "input_text" }, [
        _c("div", [
          _c("label", [
            _vm._v(_vm._s(_vm.label.street)),
            _c("span", { staticClass: "important" }, [_vm._v("必須")])
          ])
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.street,
              expression: "form.street"
            }
          ],
          attrs: { type: "text", placeholder: "町名", maxlength: "32" },
          domProps: { value: _vm.form.street },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "street", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _vm.errors.street
          ? _c("div", { staticClass: "error_text" }, [
              _vm._v(_vm._s(_vm.errors.street))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "input_text2" }, [
        _c("div", [
          _c("label", [
            _vm._v(_vm._s(_vm.label.userName)),
            _c("span", { staticClass: "important" }, [_vm._v("必須")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input_field" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.userLastName,
                expression: "form.userLastName"
              }
            ],
            attrs: { type: "text", maxlength: "32", placeholder: "家具" },
            domProps: { value: _vm.form.userLastName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "userLastName", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "space" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.userFirstName,
                expression: "form.userFirstName"
              }
            ],
            attrs: { type: "text", maxlength: "32", placeholder: "太郎" },
            domProps: { value: _vm.form.userFirstName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "userFirstName", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.errors.userName
          ? _c("div", { staticClass: "error_text" }, [
              _vm._v(_vm._s(_vm.errors.userName))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "input_text2" }, [
        _c("div", [
          _c("label", [
            _vm._v(_vm._s(_vm.label.userNameKana)),
            _c("span", { staticClass: "important" }, [_vm._v("必須")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input_field" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.userLastNameKana,
                expression: "form.userLastNameKana"
              }
            ],
            attrs: { type: "text", maxlength: "32", placeholder: "カグ" },
            domProps: { value: _vm.form.userLastNameKana },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "userLastNameKana", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "space" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.userFirstNameKana,
                expression: "form.userFirstNameKana"
              }
            ],
            attrs: { type: "text", maxlength: "32", placeholder: "タロウ" },
            domProps: { value: _vm.form.userFirstNameKana },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "userFirstNameKana", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.errors.userNameKana
          ? _c("div", { staticClass: "error_text" }, [
              _vm._v(_vm._s(_vm.errors.userNameKana))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "input_text" }, [
        _c("div", [
          _c("label", [
            _vm._v(_vm._s(_vm.label.tel)),
            _c("span", { staticClass: "small_p" }, [
              _vm._v("（半角数値、ハイフン不要）")
            ]),
            _c("span", { staticClass: "important" }, [_vm._v("必須")])
          ])
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.tel,
              expression: "form.tel"
            }
          ],
          attrs: {
            type: "text",
            oninput: "if(value.length>16)value=value.slice(0,16)",
            placeholder: "0123456789"
          },
          domProps: { value: _vm.form.tel },
          on: {
            keypress: _vm.validateNumber,
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "tel", $event.target.value)
              },
              function($event) {
                _vm.form.tel = _vm.inputRestNumber($event)
              }
            ]
          }
        }),
        _vm._v(" "),
        _vm.errors.tel
          ? _c("div", { staticClass: "error_text" }, [
              _vm._v(_vm._s(_vm.errors.tel))
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f110a19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f110a19","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/components/order/BusinessInput.vue
// module id = null
// module chunks = 